import styled, { css } from 'styled-components';
import { pxToRem, unit } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const primaryStyles = css `
  background-color: ${themeGet('colors.secondary.500')};
  color: ${themeGet('colors.primary.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.primary.0')};
  }
`;
const secondaryStyles = css `
  background-color: ${themeGet('colors.gray.50')};
  color: ${themeGet('colors.text.200')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.200')};
  }
`;
const successStyles = css `
  background-color: ${themeGet('colors.green.500')};
  color: ${themeGet('colors.gray.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }
`;
const dangerStyles = css `
  background-color: ${themeGet('colors.red.500')};
  color: ${themeGet('colors.gray.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }
`;
const warningStyles = css `
  background-color: ${themeGet('colors.yellow.500')};
  color: ${themeGet('colors.text.300')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.300')};
  }
`;
const infoStyles = css `
  background-color: ${themeGet('colors.blue.500')};
  color: ${themeGet('colors.gray.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }
`;
const lightStyles = css `
  background-color: ${themeGet('colors.gray.0')};
  color: ${themeGet('colors.text.300')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.300')};
  }
`;
const darkStyles = css `
  background-color: ${themeGet('colors.gray.1000')};
  color: ${themeGet('colors.gray.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }
`;
const mediumDotSizeStyles = css `
  height: ${unit('md')};
  width: ${unit('md')};
  border-radius: 100%;
  left: calc(100% - ${unit('md')});
  transform: translate(-20%, 20%);
`;
const mediumSizeStyles = css `
  font-size: ${themeGet('fontSize.medium')};
  height: ${unit('2xl')};
  min-width: ${unit('2xl')};
  border-radius: ${unit('2xl')};
  padding: ${pxToRem(6)};
  left: calc(100% - ${unit('2xl')} / 2);

  [data-icon='falcon'] {
    height: ${unit('lg')};
    width: ${pxToRem(9)};
  }
`;
const smallDotSizeStyles = css `
  height: ${unit('sm')};
  width: ${unit('sm')};
  border-radius: 100%;
  left: calc(100% - ${unit('sm')});
  transform: translate(-150%, 50%);
`;
const smallSizeStyles = css `
  font-size: ${themeGet('fontSize.small')};
  height: ${pxToRem(20)};
  min-width: ${pxToRem(20)};
  border-radius: ${pxToRem(20)};
  padding: ${unit('sm')};
  left: calc(100% - ${pxToRem(20)} / 1.5);

  [data-icon='falcon'] {
    height: ${unit('lg')};
    width: ${pxToRem(9)};
  }
`;
const largeDotSizeStyles = css `
  height: ${unit('lg')};
  min-width: ${unit('lg')};
  border-radius: 100%;
  left: calc(100% - ${unit('lg')});
  transform: translate(0%, 0%);
`;
const largeSizeStyles = css `
  font-size: ${themeGet('fontSize.large')};
  height: ${unit('3xl')};
  min-width: ${unit('3xl')};
  border-radius: ${unit('3xl')};
  padding: ${unit('md')};
  left: calc(100% - ${unit('3xl')} / 2.5);

  [data-icon='falcon'] {
    height: ${unit('xl')};
    width: ${unit('xl')};
  }
`;
const appearanceStyles = (appearance) => {
    switch (appearance) {
        case 'secondary':
            return secondaryStyles;
        case 'success':
            return successStyles;
        case 'danger':
            return dangerStyles;
        case 'info':
            return infoStyles;
        case 'dark':
            return darkStyles;
        case 'warning':
            return warningStyles;
        case 'light':
            return lightStyles;
        case 'primary':
        default:
            return primaryStyles;
    }
};
const sizeStyles = (size, dot) => {
    switch (size) {
        case 'small':
            return dot ? smallDotSizeStyles : smallSizeStyles;
        case 'large':
            return dot ? largeDotSizeStyles : largeSizeStyles;
        case 'medium':
        default:
            return dot ? mediumDotSizeStyles : mediumSizeStyles;
    }
};
const pillPositionStyles = css `
  position: absolute;
  box-sizing: border-box;
  top: 0;
  transform: translate(-20%, -20%);
`;
export const BadgeBox = styled.div `
  position: relative;
  width: max-content;
  height: max-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const Pill = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: ${themeGet('fontWeight.medium')};
  z-index: 1;

  ${({ $adjustPosition }) => $adjustPosition && pillPositionStyles};
  ${({ $appearance }) => appearanceStyles($appearance)};
  ${({ $size, $dot }) => sizeStyles($size, $dot)}
`;
